<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch5">
<div class="chapterHead">
<p class="centerImage0"><img alt="image" src="images/ch5.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-5">You want Marcie’s help. You swoop around the neighborhood, looking for Marcie’s family’s name on a mailbox. At last you find it, in front of a small two-story brick house. You peer into all the windows until you find Marcie alone in the living room. She seems to be baby-sitting her little brother, who is about two years old.</a></p><a id="pg-5">
<p class="para" style="text-indent: 5%;">You find an open window, then fly into the house. You perch on a curtain in the living room. Below, Marcie and her brother are playing a game with cardboard letters. While you watch, Marcie moves some of the letters.</p>
<p class="para" style="text-indent: 5%;">“C-A-T,” Marcie tells her brother. “That spells <em class="italic">cat</em>, Darryl. Can you say cat?”</p>
<p class="para" style="text-indent: 5%;">“I’m hungry!” the little boy cries.</p>
<p class="para" style="text-indent: 5%;">“I’ll get some Jell-O,” Marcie says. “See if you can spell cat.” She disappears into the hall.</p>
<p class="para" style="text-indent: 5%;">What luck! you think. The letters are small and lightweight! You’re sure you’ll be able to move them yourself and write out a message to Marcie!</p>
<p class="para" style="text-indent: 5%;">You swoop down to the floor. The letters are in a big box. You start to sort through the letters when Darryl suddenly reaches for you.</p>
<p class="para" style="text-indent: 5%;">“DOGGIE!” he cries. He grabs one of your wings and pulls.</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-5"><em class="italic">Turn to </em></a><span href="#/e9780545841030_ch042" title="Link target outside of Sample"><em class="italic">PAGE 42</em></span>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841030_ch005.vue?7d160afa